import { createSlice } from '@reduxjs/toolkit';
import {
    addEvidenceList,
    editEvidenceList,
    fetchEvidenceList,
    getEvidenceList,
    exportToPDF,
    deleteEvidenceList,
    fetchAvailableYears,
    lastYearBalance,
    addLastYearBalance,
    getIncomeDisposal
}  from '../actions/evidenceList';

const INITIAL_CURRENT = {
    waste: [],
    wasteCode: { wasteCode: '' },
    lastYearBalance: 0,
    summary: {},
};

export const evidenceListSlice = createSlice({
    name: 'evidenceList',
    initialState: {
        loading: false,
        data: [],
        current: INITIAL_CURRENT,
        pdfGenerated: false,
        error: null,
        remove: false,
        currentLoading: false,
        availableYears: [],
    },
    reducers: {
        resetCurrentEvidenceList: (state) => {
            state.current = INITIAL_CURRENT;
            state.currentLoading = false;
        },
        resetEvidenceList: (state) => {
            state.data = [];
            state.availableYears = [];
        },
    },
    extraReducers:(builder) => {
        builder
        // ADD EVIDENCE LIST
        .addCase(addEvidenceList.pending,(state) => { state.loading = true })
        .addCase(addEvidenceList.fulfilled,(state, action) => { 
            state.loading = false;
            state.data = action.payload
        })
        .addCase(addEvidenceList.rejected, (state) => { state.loading = false  })
        // FETCH EVIDENCE LISTS
        .addCase(fetchEvidenceList.pending,(state) => { 
            state.loading = true;
        })
        .addCase(fetchEvidenceList.fulfilled,(state, action) => { 
            state.loading = false;
            state.data = action.payload;
        })
        .addCase(fetchEvidenceList.rejected, (state) => { state.loading = false  })
        // GET EVIDENCE LIST BY ID
        .addCase(getEvidenceList.pending,(state) => {
            state.current = INITIAL_CURRENT;
            state.currentLoading = true;
        })
        .addCase(getEvidenceList.fulfilled,(state, action) => { 
            state.current = action.payload;
            state.currentLoading = false; 
        })
        .addCase(getEvidenceList.rejected, (state) => { 
            state.currentLoading = false;   
        })
        // EXPORT TO PDF
        .addCase(exportToPDF.pending, (state) => {
            state.loading = true;
            state.pdfGenerated = false;
            state.error = null;
        })
        .addCase(exportToPDF.fulfilled, (state) => {
            state.loading = false;
            state.pdfGenerated = true; 
            state.error = null;
            })
        .addCase(exportToPDF.rejected, (state, action) => {
            state.loading = false;
            state.pdfGenerated = false; 
            state.error = action.error.message;
        })
        // EDIT EVIDENCE LIST BY ID
        .addCase(editEvidenceList.pending,(state) => { 
            state.currentLoading = true;
        })
        .addCase(editEvidenceList.fulfilled,(state, action) => { 
            state.current = action.payload;
            state.currentLoading = false;
        })
        .addCase(editEvidenceList.rejected, (state) => { 
            state.currentLoading = false;  
        })
        // DELETE EVIDENCE LIST
        .addCase(deleteEvidenceList.pending,(state) => { 
            state.loading = true;
            state.remove = true;
        })
        .addCase(deleteEvidenceList.fulfilled,(state, action) => { 
            state.loading = false;
            state.current = {
                waste: []
            };
            state.remove = false;
        })
        .addCase(deleteEvidenceList.rejected, (state) => { 
            state.loading = false;
            state.remove = false;  
        })
        // FETCH AVAILABLE YEARS
        .addCase(fetchAvailableYears.pending,(state) => { 
            state.loading = true;
        })
        .addCase(fetchAvailableYears.fulfilled,(state, action) => {
            state.loading = false;
            state.availableYears = action.payload;
        })
        .addCase(fetchAvailableYears.rejected, (state) => { 
            state.loading = false;

        })
        // LAST YEAR BALANCE OF EVIDENCE SHEET
        .addCase(lastYearBalance.pending,(state) => { 
            // state.currentLoading = true;
        })
        .addCase(lastYearBalance.fulfilled,(state, action) => {
            // state.currentLoading = false;
            state.current.lastYearBalance =  action.payload
        })
        .addCase(lastYearBalance.rejected, (state) => { 
            // state.currentLoading = false;

        })
        // ADD LAST YEAR BALANCE
        .addCase(addLastYearBalance.pending,(state) => { 
            state.currentLoading = true;
            state.error = null;
        })
        .addCase(addLastYearBalance.fulfilled,(state, action) => {
            state.currentLoading = false;
            state.error = null;
        })
        .addCase(addLastYearBalance.rejected, (state, action) => { 
            state.currentLoading = false;
            state.error = action.error.message;

        })
          // INCOME, DISPOSAL AND BALANCE OF EVIDENCE LIST
        .addCase(getIncomeDisposal.pending,(state) => { 
            // state.currentLoading = true;
        })
        .addCase(getIncomeDisposal.fulfilled,(state, action) => {
            // state.currentLoading = false;
            state.current.summary =  action.payload
        })
        .addCase(getIncomeDisposal.rejected, (state) => { 
            // state.currentLoading = false;

        });
    }
});

export const { resetCurrentEvidenceList, resetEvidenceList } = evidenceListSlice.actions;
export default evidenceListSlice.reducer;
